import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type {
  TListCompanyBusinessDocumentsParams,
  TListCompanyBusinessDocumentsResponse,
} from "./listCompanyBusinessDocuments.schema";

export const listCompanyBusinessDocuments = (axios: IAxiosInstance) => {
  return async (
    params: TListCompanyBusinessDocumentsParams
  ): Promise<TListCompanyBusinessDocumentsResponse> => {
    const { companyID } = params;
    const response = await axios.noRetry.get<
      IApiResponse<TListCompanyBusinessDocumentsResponse>
    >(`/api/companies/${companyID}/business-documents`);
    const resData = response.data;
    if (resData?.success && resData.data) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
